import Data from './Data';

const IntroductionBlockSidebar = (props) => {
  return <Data {...props} />;
};

export default IntroductionBlockSidebar;
